import { Component, OnInit } from "@angular/core";

import { HidService } from "src/app/services/common/hid.service";
//import { CIDService } from "src/app/services/common/cid.service";
//import { BIDService } from "src/app/services/common/bid.service";
import { MatDialogRef } from "@angular/material";
import { ContractService } from "src/app/services/http/business/contract/contract.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { CIDService } from "src/app/services/common/cid.service";
import { BIDService } from "src/app/services/common/bid.service";

@Component({
  selector: "app-choose-branch-entry",
  templateUrl: "./choose-branch-entry.component.html",
  styleUrls: ["./choose-branch-entry.component.css"]
})
export class ChooseBranchEntryComponent implements OnInit {
  bid: string;
  cid: string;
  form: FormGroup;
  isOwner: boolean;
  branchList: any;
  branchSelected: any;
  constructor(
    private fb: FormBuilder,
    //private cidService: CIDService,
    //private bidService: BIDService,
    private hidService: HidService,
    private cidService: CIDService,
    private bidService: BIDService,
    private contractService: ContractService,
    private dialogRef: MatDialogRef<ChooseBranchEntryComponent>
  ) { }
  holdingCode = this.hidService.getHID();

  ngOnInit() {
    this.createForm();
    this.getBranchList();
  }

  createForm() {
    this.form = this.fb.group({
      branch: [
        // this.bidService.getBID().toString(),
        Validators.compose([Validators.required])
      ]
    });
  }

  getBranchList() {
    debugger
    this.contractService.GetBranchThatUserHasContract().subscribe(res => {
      this.branchList = res;
      // this.bid = res.BranchEncryptId;
      //this.cid = res.CompanyEncryptId;
    });
  }

  // fillLocalStorage(e: MatSelectChange) {
  //   this.branchList.filter(co => {
  //     co.BranchEncryptId = e.value;
  //     this.cid = co.CompanyEncryptId;
  //     this.bid = co.BranchEncryptId;
  //   });
  // }

  fillLocalStorage(e: any) {
    debugger
    this.branchSelected = e;
    // debugger;
    // this.brancSelectedName = branchSelected.BranchName;
    // this.roleSelectedName = branchSelected.RoleTitle;
    // this.cid = this.branchList.filter(co => {
    //   return co.BranchEncryptId == e.value;
    // })[0].CompanyEncryptId;
    // this.bid = this.branchList.filter(co => {
    //   return co.BranchEncryptId == e.value;
    // })[0].BranchEncryptId;
    // this.bName = this.branchList.filter(co => {
    //   return co.BranchEncryptId == e.value;
    // })[0].BranchName;

    // let contractTypeId = this.branchList.filter(function (item) {
    //   return item.BranchEncryptId == e.value
    // })[0].ContractTypeId;
    // if (contractTypeId === 121 || contractTypeId === 123 || contractTypeId === 124)
    //   this.isTeacherContractSelected = true;
    // else
    //   this.isTeacherContractSelected = false;
  }

  submit(_data: any) {
    this.cidService.removeCID();
    this.bidService.removeBID();
    this.cidService.setCID(this.branchSelected.CompanyEncryptId);
    this.bidService.setBID(this.branchSelected.BranchEncryptId);
    this.cidService.setBrnachRoleName(this.branchSelected.BranchName, this.branchSelected.RoleTitle);
    setTimeout(function () {
      document.location.reload(true);
    }, 2000)
    //this.router.navigate(["management"]);
  }

  onClose() {
    this.dialogRef.close();
  }
}
